const main = {};

main.copy = (obj) => {
    if (!obj) {
        return obj;
    }
    return JSON.parse(JSON.stringify(obj));
};
main.genUrl = (url, params) => {
    const queryArr = [];
    Object.keys(params).forEach((v) => {
        queryArr.push(`${v}=${params[v]}`);
    });
    return `${url}?${queryArr.join('&')}`;
};
main.genYearEnum = (from, to) => {
    const yearEnum = [];
    const nowYear = (new Date()).getFullYear();
    let startYear = 2015;
    let endYear = nowYear;
    if (from) {
        startYear = from;
    }
    if (to) {
        endYear = to;
    }
    for (let i = startYear; i <= endYear; i += 1) {
        yearEnum.push({
            name: i,
            value: i,
        });
    }
    return yearEnum;
};

main.checkParams = (paramsObj, conditions) => {
    let result = true;
    const paramsObjCopy = main.copy(paramsObj);
    const conditionsCopy = main.copy(conditions);
    delete paramsObjCopy.page;
    delete paramsObjCopy.pageSize;
    delete conditionsCopy.page;
    delete conditionsCopy.pageSize;
    const paramsKeys = Object.keys(paramsObjCopy);
    const conditionsKeys = Object.keys(conditionsCopy);
    if (conditionsKeys.length !== paramsKeys.length) {
        return false;
    }
    for (let i = 0; i < paramsKeys.length; i += 1) {
        const key = paramsKeys[i];
        if (conditions[key] !== paramsObj[key]) {
            result = false;
            break;
        }
    }
    return result;
};

export default main;
